export const concatenatePathAndCatchAll = (
  path: string,
  catchAll?: string
): string => {
  if (catchAll === undefined) return path;
  if (path === '/') return `/*${catchAll}`;
  return `${path}/*${catchAll}`;
};
